import React from "react";

interface ToggleButtonProps {
    isOpen: boolean;
    onToggle: () => void;
    className?: string;
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({
    isOpen,
    onToggle,
    className = "",
}) => {
    return (
        <button
            onClick={onToggle}
            className={`p-1 ${className}`}
            aria-label={isOpen ? "Collapse" : "Expand"}
        >
            <svg
                className={`h-5 w-5 transform transition-transform ${isOpen ? "rotate-180" : ""
                    }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 15l7-7 7 7"
                />
            </svg>
        </button>
    );
};
